import { useState, useEffect } from "react";
import { getRatingData } from "../utils";
import { RatingSectionContainer } from "./index.styled";
import StarRating from "../../StarRating";
import { useDashboard } from "../../../../hooks/useDashboard";
import { useDashboardFilter } from "../../../../contexts/DashboardFilterContext";
import type { Ratings } from "../../../../types/dashboard";

interface RatingSectionProps {
  ratings?: Ratings | null;
}

const RatingSection = ({ ratings }: RatingSectionProps) => {
  const { ratingsFiltered, refetchRatingsData, status } = useDashboard();
  const { selectedMonth } = useDashboardFilter();

  // Use filtered ratings if available, otherwise fall back to the passed ratings
  const currentRatings = ratingsFiltered || ratings;
  const { rating, ratingCount } = getRatingData(currentRatings);
  const [animatedRating, setAnimatedRating] = useState(0);

  // Fetch ratings data when month selection changes
  useEffect(() => {
    if (selectedMonth !== undefined && status?.id) {
      // Create ISO 8601 date strings for the selected month
      const year = new Date().getFullYear();
      const fromDate = new Date(year, selectedMonth - 1, 1).toISOString();
      const toDate = new Date(
        year,
        selectedMonth,
        0,
        23,
        59,
        59,
        999
      ).toISOString();

      refetchRatingsData(status.id, fromDate, toDate);
    }
  }, [selectedMonth, refetchRatingsData, status?.id]);

  return (
    <RatingSectionContainer>
      <StarRating
        rating={rating}
        size={16}
        onRatingChange={setAnimatedRating}
      />
      <div className="rating-text-container">
        <div className="rating-title">הדירוג שלך</div>
        <div className="rating-value">{animatedRating.toFixed(1)}</div>
      </div>
      <div className="rating-count">{ratingCount} צופים שדירגו</div>
    </RatingSectionContainer>
  );
};

export default RatingSection;
